import React from "react";
import { Link } from "react-router-dom";
import {
  FaMapMarkerAlt,
  FaClock,
  FaRoad,
  FaArrowRight,
  FaBus,
} from "react-icons/fa";
import "./RouteCard.css";

const RouteCard = ({ route, onViewDetails }) => {
  /* Auto-generate a short badge from routeName */
  const badge = route.routeName
    .split("→")
    .map((part) => part.trim().slice(0, 3).toUpperCase())
    .join("-");

  /* Build comma-separated pickup points string */
  const pickupPointsText = route.routePoints
    .map((p) => p.name)
    .join(", ");

  return (
    <div className="staffline-route-card">

      {/* ===== TOP STRIP ===== */}
      <div className="staffline-route-card-top">
        <span className="staffline-route-card-badge">{badge}</span>
        <span className="staffline-route-card-price">
          <strong>{route.routePrice}</strong> GHS
        </span>
      </div>

      {/* ===== ROUTE NAME ===== */}
      <h3 className="staffline-route-card-title">{route.routeName}</h3>

      {/* ===== META (duration + distance) ===== */}
      <div className="staffline-route-card-meta">
        <div className="staffline-route-card-meta-item">
          <FaClock />
          <span>{route.routeDuration}</span>
        </div>
        <div className="staffline-route-card-meta-divider"></div>
        <div className="staffline-route-card-meta-item">
          <FaRoad />
          <span>{route.routeDistance}</span>
        </div>
      </div>

      {/* ===== ROUTE POINTS (comma-separated) ===== */}
      <div className="staffline-route-card-points">
        <div className="staffline-route-card-points-header">
          <FaMapMarkerAlt />
          <span>
            {route.routePoints.length} Pickup Points
          </span>
        </div>
        <p className="staffline-route-card-points-text">
          {pickupPointsText}
        </p>
      </div>

      {/* ===== ROUTE LINE (start → end) ===== */}
      <div className="staffline-route-card-line">
        <div className="staffline-route-card-line-end">
          <span className="staffline-route-card-line-dot"></span>
          <div>
            <strong>Start</strong>
            <span>{route.routeStart}</span>
          </div>
        </div>
        <div className="staffline-route-card-line-track">
          <FaBus />
        </div>
        <div className="staffline-route-card-line-end staffline-route-card-line-end-right">
          <span className="staffline-route-card-line-dot staffline-route-card-line-dot-orange"></span>
          <div>
            <strong>End</strong>
            <span>{route.routeEnd}</span>
          </div>
        </div>
      </div>

      {/* ===== ACTIONS ===== */}
      <div className="staffline-route-card-actions">
        <button
          className="staffline-route-card-btn-secondary"
          onClick={onViewDetails}
        >
          View Details
        </button>
        <Link
          to="/subscription"
          className="staffline-route-card-btn-primary"
        >
          Subscribe <FaArrowRight />
        </Link>
      </div>

    </div>
  );
};

export default RouteCard;